/* EHR Coded Dashboard - Full Interactivity + Demo Animation */
(function () {
  'use strict';

  function initEhrDashboard() {
    var dash = document.getElementById('euiDashboard');
    if (!dash) return;

    var toast = document.getElementById('euiToast');
    var modal = document.getElementById('euiModal');
    var modalTitle = document.getElementById('euiModalTitle');
    var modalBody = document.getElementById('euiModalBody');
    var modalClose = document.getElementById('euiModalClose');

    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add('eui-toast-show');
      setTimeout(function () { toast.classList.remove('eui-toast-show'); }, 2000);
    }

    function showModal(title, body) {
      if (!modal) return;
      modalTitle.textContent = title;
      modalBody.innerHTML = body;
      modal.classList.add('eui-modal-open');
    }

    if (modalClose) {
      modalClose.addEventListener('click', function () { modal.classList.remove('eui-modal-open'); });
    }
    if (modal) {
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.classList.remove('eui-modal-open'); });
    }

    // === Navigation ===
    var navItems = dash.querySelectorAll('.eui-nav-item');
    var mainPatients = document.getElementById('euiMainPatients');
    var sidebar = document.getElementById('euiSidebar');
    var navPanels = dash.querySelectorAll('.eui-nav-content');

    navItems.forEach(function (item) {
      item.addEventListener('click', function () {
        navItems.forEach(function (n) { n.classList.remove('eui-active'); });
        item.classList.add('eui-active');
        var nav = item.getAttribute('data-nav');
        if (nav === 'patients') {
          mainPatients.style.display = '';
          sidebar.style.display = '';
          navPanels.forEach(function (p) { p.classList.remove('eui-nav-active'); });
        } else {
          mainPatients.style.display = 'none';
          sidebar.style.display = 'none';
          navPanels.forEach(function (p) {
            p.classList.toggle('eui-nav-active', p.getAttribute('data-panel') === nav);
          });
        }
      });
    });

    // === Delegated click handler ===
    dash.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-eui-dropdown]');
      if (trigger) {
        e.stopPropagation();
        var menuId = trigger.getAttribute('data-eui-dropdown');
        var menu = dash.querySelector('#' + menuId);
        if (menu) {
          dash.querySelectorAll('.eui-dropdown-menu.eui-open').forEach(function (m) {
            if (m.id !== menuId) m.classList.remove('eui-open');
          });
          menu.classList.toggle('eui-open');
        }
        return;
      }

      var dropItem = e.target.closest('.eui-dropdown-item');
      if (dropItem) {
        var ddMenu = dropItem.closest('.eui-dropdown-menu');
        var ddTrigger = dash.querySelector('[data-eui-dropdown="' + ddMenu.id + '"]');
        if (ddTrigger) {
          var valEl = ddTrigger.querySelector('.eui-dd-value');
          if (valEl) valEl.textContent = dropItem.textContent;
        }
        ddMenu.classList.remove('eui-open');
        return;
      }

      if (!e.target.closest('.eui-dropdown-menu')) {
        dash.querySelectorAll('.eui-dropdown-menu.eui-open').forEach(function (m) { m.classList.remove('eui-open'); });
      }

      var collapsible = e.target.closest('.eui-hr-hdr');
      if (collapsible) {
        var section = collapsible.closest('.eui-hr-sec');
        var list = section.querySelector('.eui-hr-list');
        if (list) {
          var isHidden = list.style.display === 'none';
          list.style.display = isHidden ? '' : 'none';
          var arrow = section.querySelector('.eui-hr-arrow');
          if (arrow) arrow.innerHTML = isHidden ? '&#9660;' : '&#9654;';
        }
        return;
      }

      var collapsed = e.target.closest('.eui-hr-collapsed');
      if (collapsed) {
        var arr = collapsed.querySelector('.eui-arr');
        if (arr) arr.innerHTML = arr.textContent.charCodeAt(0) === 9654 ? '&#9660;' : '&#9654;';
        return;
      }

      var tab = e.target.closest('.eui-tab');
      if (tab) {
        dash.querySelectorAll('.eui-tab').forEach(function (t) { t.classList.remove('eui-tab-on'); });
        tab.classList.add('eui-tab-on');
        return;
      }

      var actionBtn = e.target.closest('[data-action]');
      if (actionBtn) {
        actionBtn.style.transform = 'scale(0.95)';
        setTimeout(function () { actionBtn.style.transform = ''; }, 150);
        return;
      }

      var btn = e.target.closest('.eui-act-btn, .eui-import-btn, .eui-import-visit-btn, .eui-load-btn');
      if (btn) {
        btn.style.transform = 'scale(0.95)';
        setTimeout(function () { btn.style.transform = ''; }, 150);
        return;
      }
    });

    // === Add assessment ===
    var addAssessment = document.getElementById('euiAddAssessment');
    if (addAssessment) {
      addAssessment.addEventListener('click', function () {
        var soapLeft = dash.querySelector('.eui-soap-left');
        var count = soapLeft.querySelectorAll('.eui-assessment-val').length + 1;
        var newRow = document.createElement('div');
        newRow.className = 'eui-field-row eui-mt-sm';
        newRow.innerHTML = '<span class="eui-field-lbl">' + count + ' :</span><div class="eui-field-input eui-assessment-val" contenteditable="true" data-placeholder="Enter assessment..." tabindex="0"></div>';
        addAssessment.parentNode.insertBefore(newRow, addAssessment);
        newRow.querySelector('[contenteditable]').focus({preventScroll:true});
      });
    }

    // === Focus effects ===
    dash.querySelectorAll('.eui-field-input[contenteditable], .eui-plan-input[contenteditable], .eui-pe-box[contenteditable]').forEach(function (el) {
      el.addEventListener('focus', function () {
        this.style.borderColor = '#4a90c4';
        this.style.boxShadow = '0 0 0 2px rgba(74, 144, 196, 0.15)';
        if (this.classList.contains('eui-placeholder')) this.classList.remove('eui-placeholder');
      });
      el.addEventListener('blur', function () { this.style.borderColor = ''; this.style.boxShadow = ''; });
    });

    // === Reminders ===
    dash.querySelectorAll('.eui-rem-dismiss').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var row = this.closest('.eui-rem-alert-row');
        if (row) {
          row.style.transition = 'opacity 0.3s, max-height 0.3s';
          row.style.opacity = '0';
          row.style.maxHeight = '0';
          row.style.overflow = 'hidden';
          setTimeout(function () { row.style.display = 'none'; }, 300);
        }
      });
    });

    dash.querySelectorAll('.eui-rem-noted').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        this.style.color = '#5b9e4d';
        this.style.fontWeight = '600';
        this.textContent = '\u2713 Noted';
      });
    });

    // === Sidebar hover ===
    dash.querySelectorAll('.eui-hr-item').forEach(function (item) {
      item.style.transition = 'background 0.15s';
      item.style.borderRadius = '3px';
      item.style.cursor = 'pointer';
      item.addEventListener('mouseenter', function () { this.style.background = '#f0f4f8'; });
      item.addEventListener('mouseleave', function () { this.style.background = ''; });
    });

    // === DNR pulse ===
    var dnr = dash.querySelector('.eui-dnr');
    if (dnr) dnr.style.animation = 'euiPulse 2s ease-in-out infinite';
    if (!document.getElementById('euiPulseStyle')) {
      var ps = document.createElement('style');
      ps.id = 'euiPulseStyle';
      ps.textContent = '@keyframes euiPulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.7; } }';
      document.head.appendChild(ps);
    }

    // === Search focus ===
    var searchInput = dash.querySelector('.eui-search-input');
    if (searchInput && searchInput.tagName === 'INPUT') {
      searchInput.addEventListener('focus', function () {
        this.style.background = 'rgba(255,255,255,0.18)';
        this.style.borderColor = 'rgba(255,255,255,0.35)';
      });
      searchInput.addEventListener('blur', function () {
        this.style.background = 'rgba(255,255,255,0.1)';
        this.style.borderColor = 'rgba(255,255,255,0.15)';
      });
    }

    // =============================================
    // ===== DEMO ANIMATION (step-queue) =====
    // =============================================
    var cursor = document.getElementById('euiCursor');
    if (!cursor) return;

    var demoTimer = null;
    var steps = [];
    var stepIdx = 0;

    function getPos(el) {
      var r = el.getBoundingClientRect();
      var wr = dash.getBoundingClientRect();
      return { x: r.left - wr.left + r.width / 2, y: r.top - wr.top + r.height / 2 };
    }

    function next() {
      if (stepIdx >= steps.length) {
        stepIdx = 0;
        resetState();
        demoTimer = setTimeout(next, 1800);
        return;
      }
      steps[stepIdx]();
      stepIdx++;
    }

    function delay(ms) {
      steps.push(function () { demoTimer = setTimeout(next, ms); });
    }

    function moveCursor(sel) {
      steps.push(function () {
        var el = typeof sel === 'string' ? dash.querySelector(sel) : sel;
        if (!el) { next(); return; }
        var p = getPos(el);
        cursor.style.left = p.x + 'px';
        cursor.style.top = p.y + 'px';
        demoTimer = setTimeout(next, 650);
      });
    }

    function click(sel) {
      steps.push(function () {
        var el = typeof sel === 'string' ? dash.querySelector(sel) : sel;
        if (!el) { next(); return; }
        cursor.classList.add('eui-cursor-click');
        el.classList.add('eui-demo-highlight');
        // ripple
        var p = getPos(el);
        var rip = document.createElement('div');
        rip.className = 'eui-click-ripple';
        rip.style.left = (p.x - 10) + 'px';
        rip.style.top = (p.y - 10) + 'px';
        dash.appendChild(rip);
        setTimeout(function () { rip.remove(); }, 600);
        setTimeout(function () {
          cursor.classList.remove('eui-cursor-click');
          el.classList.remove('eui-demo-highlight');
        }, 350);
        demoTimer = setTimeout(next, 450);
      });
    }

    function typeInto(sel, text) {
      steps.push(function () {
        var el = typeof sel === 'string' ? dash.querySelector(sel) : sel;
        if (!el) { next(); return; }
        var isInput = el.tagName === 'INPUT' || el.tagName === 'TEXTAREA';
        el.classList.add('eui-typing-active');
        if (isInput) { el.value = ''; } else { el.textContent = ''; }
        var i = 0;
        function typ() {
          if (i < text.length) {
            if (isInput) { el.value += text[i]; } else { el.textContent += text[i]; }
            i++;
            demoTimer = setTimeout(typ, 45 + Math.random() * 35);
          } else {
            el.classList.remove('eui-typing-active');
            demoTimer = setTimeout(next, 350);
          }
        }
        typ();
      });
    }

    function openDd(triggerId, itemIdx) {
      // move to trigger
      moveCursor('[data-eui-dropdown="' + triggerId + '"]');
      // click trigger
      click('[data-eui-dropdown="' + triggerId + '"]');
      // open menu
      steps.push(function () {
        var menu = dash.querySelector('#' + triggerId);
        if (menu) menu.classList.add('eui-open');
        demoTimer = setTimeout(next, 400);
      });
      // move to item
      steps.push(function () {
        var menu = dash.querySelector('#' + triggerId);
        if (!menu) { next(); return; }
        var items = menu.querySelectorAll('.eui-dropdown-item');
        var item = items[itemIdx] || items[0];
        var p = getPos(item);
        cursor.style.left = p.x + 'px';
        cursor.style.top = p.y + 'px';
        demoTimer = setTimeout(next, 500);
      });
      // click item
      steps.push(function () {
        var menu = dash.querySelector('#' + triggerId);
        var trigger = dash.querySelector('[data-eui-dropdown="' + triggerId + '"]');
        if (!menu) { next(); return; }
        var items = menu.querySelectorAll('.eui-dropdown-item');
        var item = items[itemIdx] || items[0];
        cursor.classList.add('eui-cursor-click');
        item.style.background = '#e8f0f8';
        var valEl = trigger ? trigger.querySelector('.eui-dd-value') : null;
        if (valEl) valEl.textContent = item.textContent;
        setTimeout(function () {
          cursor.classList.remove('eui-cursor-click');
          item.style.background = '';
          menu.classList.remove('eui-open');
        }, 350);
        demoTimer = setTimeout(next, 500);
      });
    }

    function clickBtn(sel) {
      moveCursor(sel);
      click(sel);
      steps.push(function () {
        var el = typeof sel === 'string' ? dash.querySelector(sel) : sel;
        if (el) {
          el.style.transform = 'scale(0.93)';
          setTimeout(function () { el.style.transform = ''; }, 200);
        }
        demoTimer = setTimeout(next, 400);
      });
    }

    function clickTab(idx) {
      steps.push(function () {
        var tabs = dash.querySelectorAll('.eui-tab');
        var tab = tabs[idx];
        if (!tab) { next(); return; }
        var p = getPos(tab);
        cursor.style.left = p.x + 'px';
        cursor.style.top = p.y + 'px';
        demoTimer = setTimeout(next, 600);
      });
      steps.push(function () {
        var tabs = dash.querySelectorAll('.eui-tab');
        var tab = tabs[idx];
        if (!tab) { next(); return; }
        cursor.classList.add('eui-cursor-click');
        tab.classList.add('eui-demo-highlight');
        var rip = document.createElement('div');
        rip.className = 'eui-click-ripple';
        var p = getPos(tab);
        rip.style.left = (p.x - 10) + 'px';
        rip.style.top = (p.y - 10) + 'px';
        dash.appendChild(rip);
        setTimeout(function () { rip.remove(); }, 600);
        tabs.forEach(function (t) { t.classList.remove('eui-tab-on'); });
        tab.classList.add('eui-tab-on');
        setTimeout(function () {
          cursor.classList.remove('eui-cursor-click');
          tab.classList.remove('eui-demo-highlight');
        }, 350);
        demoTimer = setTimeout(next, 500);
      });
    }

    function clickNav(navName) {
      steps.push(function () {
        var item = dash.querySelector('.eui-nav-item[data-nav="' + navName + '"]');
        if (!item) { next(); return; }
        var p = getPos(item);
        cursor.style.left = p.x + 'px';
        cursor.style.top = p.y + 'px';
        demoTimer = setTimeout(next, 600);
      });
      steps.push(function () {
        var item = dash.querySelector('.eui-nav-item[data-nav="' + navName + '"]');
        if (!item) { next(); return; }
        cursor.classList.add('eui-cursor-click');
        item.classList.add('eui-demo-highlight');
        navItems.forEach(function (n) { n.classList.remove('eui-active'); });
        item.classList.add('eui-active');
        var nav = navName;
        if (nav === 'patients') {
          mainPatients.style.display = '';
          sidebar.style.display = '';
          navPanels.forEach(function (pp) { pp.classList.remove('eui-nav-active'); });
        } else {
          mainPatients.style.display = 'none';
          sidebar.style.display = 'none';
          navPanels.forEach(function (pp) {
            pp.classList.toggle('eui-nav-active', pp.getAttribute('data-panel') === nav);
          });
        }
        setTimeout(function () {
          cursor.classList.remove('eui-cursor-click');
          item.classList.remove('eui-demo-highlight');
        }, 350);
        demoTimer = setTimeout(next, 500);
      });
    }

    function typeField(sel, text) {
      moveCursor(sel);
      click(sel);
      typeInto(sel, text);
    }

    function typeFieldByIndex(parentSel, idx, text) {
      steps.push(function () {
        var fields = dash.querySelectorAll(parentSel);
        var el = fields[idx];
        if (!el) { next(); return; }
        var p = getPos(el);
        cursor.style.left = p.x + 'px';
        cursor.style.top = p.y + 'px';
        demoTimer = setTimeout(next, 600);
      });
      steps.push(function () {
        var fields = dash.querySelectorAll(parentSel);
        var el = fields[idx];
        if (!el) { next(); return; }
        cursor.classList.add('eui-cursor-click');
        el.classList.add('eui-demo-highlight');
        var rip = document.createElement('div');
        rip.className = 'eui-click-ripple';
        var p = getPos(el);
        rip.style.left = (p.x - 10) + 'px';
        rip.style.top = (p.y - 10) + 'px';
        dash.appendChild(rip);
        setTimeout(function () { rip.remove(); }, 600);
        setTimeout(function () {
          cursor.classList.remove('eui-cursor-click');
          el.classList.remove('eui-demo-highlight');
        }, 350);
        demoTimer = setTimeout(next, 400);
      });
      steps.push(function () {
        var fields = dash.querySelectorAll(parentSel);
        var el = fields[idx];
        if (!el) { next(); return; }
        el.classList.add('eui-typing-active');
        el.textContent = '';
        var i = 0;
        function typ() {
          if (i < text.length) {
            el.textContent += text[i];
            i++;
            demoTimer = setTimeout(typ, 45 + Math.random() * 35);
          } else {
            el.classList.remove('eui-typing-active');
            demoTimer = setTimeout(next, 350);
          }
        }
        typ();
      });
    }

    function dismissRem(idx) {
      steps.push(function () {
        var btns = dash.querySelectorAll('.eui-rem-dismiss');
        var btn = btns[idx];
        if (!btn || btn.closest('.eui-rem-alert-row').style.display === 'none') { next(); return; }
        var p = getPos(btn);
        cursor.style.left = p.x + 'px';
        cursor.style.top = p.y + 'px';
        demoTimer = setTimeout(next, 600);
      });
      steps.push(function () {
        var btns = dash.querySelectorAll('.eui-rem-dismiss');
        var btn = btns[idx];
        if (!btn) { next(); return; }
        cursor.classList.add('eui-cursor-click');
        var row = btn.closest('.eui-rem-alert-row');
        if (row) {
          row.style.transition = 'opacity 0.3s, max-height 0.3s';
          row.style.opacity = '0';
          row.style.maxHeight = '0';
          row.style.overflow = 'hidden';
          setTimeout(function () { row.style.display = 'none'; }, 300);
        }
        setTimeout(function () { cursor.classList.remove('eui-cursor-click'); }, 350);
        demoTimer = setTimeout(next, 500);
      });
    }

    // Type into data-demo-field inputs
    function typeDemoField(fieldName, text) {
      var sel = '[data-demo-field="' + fieldName + '"]';
      moveCursor(sel);
      click(sel);
      typeInto(sel, text);
    }

    function resetState() {
      // Reset tabs
      dash.querySelectorAll('.eui-tab').forEach(function (t, i) {
        t.classList.remove('eui-tab-on');
        if (i === 0) t.classList.add('eui-tab-on');
      });
      // Reset nav to patients
      navItems.forEach(function (n) { n.classList.remove('eui-active'); });
      var patNav = dash.querySelector('.eui-nav-item[data-nav="patients"]');
      if (patNav) patNav.classList.add('eui-active');
      if (mainPatients) mainPatients.style.display = '';
      if (sidebar) sidebar.style.display = '';
      navPanels.forEach(function (p) { p.classList.remove('eui-nav-active'); });
      // Close dropdowns
      dash.querySelectorAll('.eui-dropdown-menu.eui-open').forEach(function (m) { m.classList.remove('eui-open'); });
      // Reset reminders
      dash.querySelectorAll('.eui-rem-alert-row').forEach(function (r) {
        r.style.display = '';
        r.style.opacity = '1';
        r.style.maxHeight = '';
        r.style.overflow = '';
      });
      var rem = document.getElementById('euiReminders');
      if (rem) { rem.style.display = ''; rem.style.opacity = '1'; }
      dash.querySelectorAll('.eui-rem-noted').forEach(function (b) {
        b.style.color = '';
        b.style.fontWeight = '';
        b.textContent = 'Noted';
      });
      // Clear typed text in patient panel
      dash.querySelectorAll('.eui-field-input[contenteditable]').forEach(function (f) {
        if (f.getAttribute('data-placeholder')) f.textContent = '';
      });
      var cp = dash.querySelector('.eui-plan-input[data-placeholder]');
      if (cp) cp.textContent = '';
      var si = dash.querySelector('.eui-search-input');
      if (si && si.tagName === 'INPUT') si.value = '';
      // Reset dropdown values
      var defs = {euiPhysDd:'Albert Melbourne',euiApptDd:'In-person visit',euiLoadDd:'Load Last Note',euiRosDd:'ROS Templates'};
      for (var did in defs) {
        var dv = dash.querySelector('[data-eui-dropdown="' + did + '"] .eui-dd-value');
        if (dv) dv.textContent = defs[did];
      }
      // Clear all panel form fields
      dash.querySelectorAll('[data-demo-field]').forEach(function (f) {
        if (f.tagName === 'INPUT') f.value = '';
        else if (f.tagName === 'TEXTAREA') f.value = '';
      });
      // Restore settings defaults
      var setDefs = {'set-name':'Thinkitive Health Clinic','set-npi':'1234567890','set-addr':'456 Medical Center Dr, Suite 200','set-phone':'(555) 234-5678','set-fax':'(555) 234-5679'};
      for (var sk in setDefs) {
        var sf = dash.querySelector('[data-demo-field="' + sk + '"]');
        if (sf) sf.value = setDefs[sk];
      }
      // Park cursor
      cursor.style.left = '-30px';
      cursor.style.top = '-30px';
    }

    // ============ BUILD DEMO STEPS ============

    // --- PATIENTS TAB ---
    delay(600);
    typeField('.eui-search-input', 'Henna West');
    delay(400);
    clickBtn('.eui-act-btn[data-action="viewProfile"]');
    delay(300);

    // Physician & Appointment dropdowns
    openDd('euiPhysDd', 1);
    delay(250);
    openDd('euiApptDd', 1);
    delay(250);

    // Dismiss reminder
    dismissRem(0);
    delay(250);

    // Switch tabs
    clickTab(1);
    delay(400);
    clickTab(0);
    delay(250);

    // Fill SOAP fields
    typeFieldByIndex('.eui-soap-left .eui-field-input[contenteditable]', 1, 'Chronic lower back pain, 6 months');
    delay(200);
    typeFieldByIndex('.eui-soap-left .eui-field-input[contenteditable]', 2, 'Sulfa drugs');
    delay(200);
    clickBtn('.eui-import-btn');
    delay(200);
    typeFieldByIndex('.eui-soap-left .eui-field-input[contenteditable]', 3, 'Type 2 Diabetes');
    delay(200);
    openDd('euiRosDd', 1);
    delay(200);
    typeField('.eui-plan-input[data-placeholder]', 'PT 3x/week, follow-up 4 wks');
    delay(300);
    clickBtn('[data-action="saveDraft"]');
    delay(400);

    // --- DASHBOARD ---
    clickNav('dashboard');
    delay(600);
    clickBtn('[data-panel-action="newAppt"]');
    delay(300);
    clickBtn('[data-panel-action="viewAll"]');
    delay(300);
    clickBtn('[data-panel-action="labQueue"]');
    delay(500);

    // --- SCHEDULING ---
    clickNav('scheduling');
    delay(400);
    typeDemoField('sched-patient', 'Henna West');
    delay(150);
    typeDemoField('sched-date', '07/20/2023');
    delay(150);
    typeDemoField('sched-time', '10:30 AM');
    delay(150);
    typeDemoField('sched-provider', 'Dr. Sarah Johnson');
    delay(150);
    typeDemoField('sched-reason', 'Follow-up: Spinal Stenosis');
    delay(150);
    typeDemoField('sched-notes', 'Bring MRI results from last visit');
    delay(200);
    clickBtn('[data-panel-action="schedSave"]');
    delay(500);

    // --- COMMUNICATIONS ---
    clickNav('communications');
    delay(400);
    typeDemoField('msg-to', 'Henna West');
    delay(150);
    typeDemoField('msg-subject', 'Lab Results - Follow Up');
    delay(150);
    typeDemoField('msg-body', 'Dear Henna, your recent lab results are ready for review. Please schedule a follow-up appointment.');
    delay(200);
    clickBtn('[data-panel-action="sendMsg"]');
    delay(500);

    // --- BILLING ---
    clickNav('billing');
    delay(400);
    typeDemoField('bill-patient', 'Henna West');
    delay(150);
    typeDemoField('bill-cpt', '99214');
    delay(150);
    typeDemoField('bill-icd', 'M48.061');
    delay(150);
    typeDemoField('bill-amount', '$185.00');
    delay(200);
    clickBtn('[data-panel-action="submitClaim"]');
    delay(500);

    // --- REFERRAL ---
    clickNav('referral');
    delay(400);
    typeDemoField('ref-patient', 'Henna West');
    delay(150);
    typeDemoField('ref-to', 'Dr. Rajesh Patel');
    delay(150);
    typeDemoField('ref-specialty', 'Neurosurgery');
    delay(150);
    typeDemoField('ref-reason', 'Spinal stenosis L4-L5 with progressive symptoms, needs surgical evaluation');
    delay(200);
    clickBtn('[data-panel-action="sendRef"]');
    delay(500);

    // --- REPORTS ---
    clickNav('reports');
    delay(400);
    typeDemoField('rpt-type', 'Monthly Revenue Summary');
    delay(150);
    typeDemoField('rpt-range', 'Jul 1 - Jul 31, 2023');
    delay(200);
    clickBtn('[data-panel-action="runReport"]');
    delay(300);
    clickBtn('[data-panel-action="exportReport"]');
    delay(500);

    // --- SETTINGS ---
    clickNav('settings');
    delay(400);
    typeDemoField('set-name', 'Thinkitive EHR Clinic');
    delay(150);
    typeDemoField('set-phone', '(555) 999-1234');
    delay(200);
    clickBtn('[data-panel-action="saveSettings"]');
    delay(500);

    // --- BACK TO PATIENTS, sign note ---
    clickNav('patients');
    delay(400);
    clickBtn('[data-action="sign"]');
    delay(300);
    openDd('euiLoadDd', 1);
    delay(1500);

    // Start
    cursor.classList.add('eui-cursor-visible');
    demoTimer = setTimeout(next, 1200);

    // Pause on user interaction, resume after idle
    var idleTimer = null;
    dash.addEventListener('mousedown', function () {
      clearTimeout(demoTimer);
      cursor.classList.remove('eui-cursor-visible');
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        stepIdx = 0;
        resetState();
        cursor.classList.add('eui-cursor-visible');
        demoTimer = setTimeout(next, 1000);
      }, 8000);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEhrDashboard);
  } else {
    initEhrDashboard();
  }
})();
